import React from 'react';

import CustomLincExportBookingsForm from '../Common/Forms/CustomLincExportBookingsForm';
import CustomLincExportPaidForm from '../Common/Forms/CustomLincExportPaidForm';
import CustomLincExportPayableForm from '../Common/Forms/CustomLincExportPayableForm';
import CustomLincRefundForm from '../Common/Forms/CustomLincRefundForm';
import CustomLincUploadPaidForm from '../Common/Forms/CustomLincUploadPaidForm';

import ContentWithSidebar from './ContentWithSidebar';

const DEFAULT_ITEM = 'customlinc-bookings';

export const items = [
  {
    title: 'CustomLinc Bookings',
    slug: 'customlinc-bookings',
    component: CustomLincExportBookingsForm,
  },
  {
    title: 'CustomLinc Payable Report',
    slug: 'customlinc-payable',
    component: CustomLincExportPayableForm,
  },
  {
    title: 'CustomLinc Upload Paid',
    slug: 'customlinc-upload-paid',
    component: CustomLincUploadPaidForm,
  },
  {
    title: 'CustomLinc Paid Report',
    slug: 'customlinc-paid',
    component: CustomLincExportPaidForm,
  },
  {
    title: 'CustomLinc Refund Report',
    slug: 'customlinc-refund',
    component: CustomLincRefundForm,
  },
];

export default function CustomLincPage() {
  return <ContentWithSidebar items={items} defaultItem={DEFAULT_ITEM} />;
}
